export default __webpack_public_path__ + "static/SanFranciscoText-Regular-f616bdbf3123509644160e9a0c8b9567.woff2";